<template>
  <div id="footer">
    <div class="wrapper">
      <p>
        <router-link to="/valitse">Valitse kokeiltava sali</router-link>
        <a href="https://www.kuntokruunu.fi" target="_blank"
          >KuntoKruunun etusivu</a
        >
      </p>
      <p>
        <small>
          Lupaamme pitää sähköpostiosoitteesi turvassa. Lue tästä
          <a
            href="https://www.kuntokruunu.fi/tietosuojaseloste/"
            onclick="window.open(
                'https://www.kuntokruunu.fi/tietosuojaseloste/', 
                'newwindow', 
                'width=300,height=250'); 
     return false;"
            target="_blank"
            class="inline"
            >tietosuojaselosteemme</a
          >.
        </small>
      </p>
    </div>
    <hr />
    <div class="wrapper s-pad">
      <p>
        Toteutus:
        <a class="inline" href="https:www.creativedigiworks.fi" target="_blank"
          >Creative Digiworks</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
#footer {
  background: rgb(29, 29, 29);
  color: #fff;
  font-size: 9px;
}
#footer a {
  color: #fff;
  display: block;
}
#footer a.inline {
  display: initial;
  text-decoration: underline;
}
#footer a:not(:last-of-type) {
  margin-bottom: 10px;
}
#footer p:not(:last-of-type) {
  margin-bottom: 10px;
}
hr {
  max-width: 90%;
  margin: 0 auto;
  border-bottom: none;
}
</style>
